var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clear-both" }, [
    _c("input", {
      staticClass: "button",
      class: [
        _vm.isLoading ? "yellow" : _vm.optionValues.buttonClass || "green"
      ],
      attrs: { type: "submit", disabled: _vm.disabled || _vm.isDisabled },
      domProps: { value: _vm.button },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.save($event)
        }
      }
    }),
    _c("span", { staticClass: "form-status grey" }, [
      _vm.isLoading
        ? _c(
            "span",
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.optionValues.statesText.loading) +
                  "\n            "
              ),
              _c("base-icon16", { attrs: { id: "loading" } })
            ],
            1
          )
        : _vm._e(),
      _vm.status === _vm.STATUS.SAVED
        ? _c(
            "span",
            [
              _c("base-icon16", { attrs: { id: "yes" } }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.optionValues.statesText.saved) +
                  "\n        "
              )
            ],
            1
          )
        : _vm.status === _vm.STATUS.RELOADING
        ? _c(
            "span",
            [
              _c("base-icon16", { attrs: { id: "yes" } }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.optionValues.statesText.reloading) +
                  "\n            "
              ),
              _c("base-icon16", { attrs: { id: "loading" } })
            ],
            1
          )
        : _vm.status === _vm.STATUS.ERROR
        ? _c(
            "span",
            { staticClass: "red" },
            [
              _c("base-icon16", { attrs: { id: "no" } }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.optionValues.statesText.error) +
                  "\n        "
              )
            ],
            1
          )
        : _vm.status === _vm.STATUS.CUSTOM_ERROR
        ? _c(
            "span",
            { staticClass: "red" },
            [
              _c("base-icon16", { attrs: { id: "no" } }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.optionValues.statesText.custom) +
                  "\n        "
              )
            ],
            1
          )
        : (_vm.disabled || _vm.isDisabled) &&
          _vm.optionValues.statesText.disabled
        ? _c("span", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.optionValues.statesText.disabled) +
                "\n        "
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }